import { useQueryClient } from "@tanstack/react-query";
import { useApiQuery } from "./use-api-query";
import { queryKeys } from "../lib/query-keys";

// Profile changes rarely, so cache it longer than the 60s global default and
// rely on explicit invalidation (below) to refresh it after a write — rather
// than time-based refetching.
const PROFILE_STALE_TIME = 5 * 60_000; // 5 min

export function useProfile(enabled = true) {
  return useApiQuery<{ data?: any }>({
    queryKey: queryKeys.profile(),
    endpoint: "/user/profile",
    staleTime: PROFILE_STALE_TIME,
    enabled,
  });
}

// Call in the `onSuccess` of any mutation that changes the user's profile
// (kyc, bank details, transaction pin, password, profile edits) so the cached
// profile refreshes immediately.
export function useInvalidateProfile() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: queryKeys.profile() });
}
